<script>
/* global T */
import componentMixin from "../mixins/component-mixin";
import { toLngLat } from "../utils/converter";
import { isPointInPolygon } from "@/components/TdtMap/utils/index.js";

export default {
    name: "TdtPolygon",
    mixins: [componentMixin],
    props: {
        color: { type: String },
        weight: { type: Number },
        opacity: { type: Number },
        fillColor: { type: String },
        fillOpacity: { type: Number },
        lineStyle: { type: String },
        path: { type: Array },
        edit: { type: Boolean, default: false },
        extData: null
    },
    data() {
        return {
            lastPath: null,
            mapContextHandler: null,
            polygonMouseUpHandler: null
        };
    },
    methods: {
        initComponent(option) {
            const paths = this.path.map(item => toLngLat(item));
            this.$tdtComponent = new T.Polygon(paths, option);
            this.lastPath = this.getPathString();
            this.addCustomEvents();
        },
        addCustomEvents() {
            const { $tdtMap, $tdtComponent, extData } = this;

            this.mapContextHandler = (e) => {
                const lngLats = $tdtComponent.getLngLats()[0];
                const polygon = lngLats.map(p => [p.lng, p.lat]);
                const point = [e.lnglat.lng, e.lnglat.lat];
                if(isPointInPolygon(point, polygon)) {
                    this.$emit("contextmenu", { ...e, extData, target: $tdtComponent });
                }
            };
            $tdtMap.addEventListener("contextmenu", this.mapContextHandler);
        },
        getPathString() {
            if(!this.$tdtComponent || !this.$tdtComponent.getLngLats) return "";
            const lngLats = this.$tdtComponent.getLngLats();
            return lngLats.map(p => `${p.lng},${p.lat}`).join(";");
        },
        removeCustomEvents() {
            const { $tdtMap } = this;
            if(this.mapContextHandler && $tdtMap) {
                $tdtMap.removeEventListener("contextmenu", this.mapContextHandler);
            }
        }
    },
    beforeDestroy() {
        this.removeCustomEvents();
    },
    watch: {
        edit(val) {
            if(val) {
                this.lastPath = this.getPathString();
            }
        }
    }
};
</script>
